import type { Arrangement } from '@/lib/types';

export function pickDefaultArrangement(
  arrangements: readonly Arrangement[],
  alreadyInRepertoire: ReadonlySet<string>,
): Arrangement | null {
  if (arrangements.length === 0) return null;
  const sorted = [...arrangements].sort((a, b) =>
    a.canonicalName.localeCompare(b.canonicalName),
  );
  for (const arrangement of sorted) {
    if (!alreadyInRepertoire.has(arrangement.arrangementId)) return arrangement;
  }
  return null;
}
